import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('countries', ['countries', 'countriesLoading'])
    }
};
